import React, { Component } from 'react';
import {Button} from 'app/components/Basics/'
import './GlobalControlLineComponent.scss';
import { ReactComponent as SaveIcon } from 'app/assets/icons/Save.svg';
import {QuotaFormContext} from '../../QuotaContext'
import ValidateQuota from '../../QuotaValidation'
 
class GlobalControlLine extends Component {

    constructor(props){
        super(props);

        this.state = {            
        }        
    }

    componentWillReceiveProps(nextProps) {        
        if (nextProps && nextProps.errors) {            
            var error = nextProps.errors.find(e => e.field === "name")
            if (error) {
                this.setState({errorQuotaName: error.errorMessage})
            }
        }
    }    
	
	isSaveDisabled() {
		var errors = ValidateQuota(this.context.questionSetQuotas);
        return errors.length > 0;
	}	

	userCannotChangeData() {
		return !this.props.canChangeData;
	}

    render() {
        return (
            <div className="GlobalControlLineComponent form-row">
                <div></div>
                <div className="contol-buttons">                    
                    <Button disabled={this.userCannotChangeData() || this.isSaveDisabled()} title="Save all changes in the survey" icon={<SaveIcon/>} onClick={this.props.handleSubmitAction}>Save</Button>
                </div>
                
            </div>  
        );
    }
}
GlobalControlLine.contextType = QuotaFormContext;
export default GlobalControlLine;